import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import _CharilotoLogo from '@/assets/icons/logo_chariloto.svg';
import _DokantoLogo from '@/assets/icons/logo_dokanto.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const DateWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: `${defaultTheme.spacing.xxl} 0`,
    '& > time': {
      fontSize: defaultTheme.font.size.xl,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const StyledLink = styled(Link)(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.s,
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);

export const CharilotoLogo = styled.i(() =>
  mq({
    display: 'block',
    width: ['128px', '128px', '168px', '168px'],
    height: ['24px', '24px', '32px', '32px'],
    backgroundImage: `url(${_CharilotoLogo})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const DokantoLogo = styled(CharilotoLogo)(() =>
  mq({
    width: ['128px', '128px', '153px', '153px'],
    backgroundImage: `url(${_DokantoLogo})`,
  }),
);

export const EmptyMessage = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.m,
    textAlign: 'center',
    padding: '80px 0',
  }),
);
